import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  slotMachine: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },

  slotColumn: {
    display: "flex",
    flexDirection: "column",
    gap: 16,

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  slotPanels: {
    display: "flex",
    width: "100%",
    gap: 16,
    justifyContent: "center",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
}));

export default styles;
